(function ($, Global) {
    function BlocAccountComponent() {
        // Déclaration class objet
    }

	BlocAccountComponent.prototype.initEvents = function () {
		this.publishers();
		this.subscribers();
	};

    BlocAccountComponent.prototype.publishers = function () {
        $(document).on('click', '.bloc-account .close', function () {
            $(this).closest('.bloc-account').removeClass('in');
        });
    };

    BlocAccountComponent.prototype.subscribers = function () {
        $.Topic('show-message').subscribe(function (msg, type, config) {
            var type = type || 'success';
            var btnClose = '<button class="close"><span class="icon icon-44"></span></button>';
            config = config || {}
            $('.bloc-account').removeClass('success error').addClass('in').addClass(type);
            $('.bloc-account').html(btnClose + msg);
        });
    };

	Global.BlocAccountComponent = BlocAccountComponent;
}(jQuery, window));